export default `---
slug: swift-rpa-lead
type: work
dateRange: "Dec 2024 – Feb 2025"
institution: "Swift"
location: "The Netherlands"
role: "AI and RPA Lead — Customer Support"
current: false
skills: [UiPath, Python, RPA, Process Automation, AI Strategy, GenAI, Prompt Engineering]
relatedLinks:
  - label: "RPA Automation Project"
    href: /projects/rpa-automation
  - label: "Salesforce Prompt Builder"
    href: /projects/salesforce-prompt-builder
---

In December 2024, I became "AI and RPA Lead" for customer support, focusing all my time on AI and RPA projects. This role formalized what I had been doing organically for months — being the person in the team who bridges technical AI capabilities with real business needs in a highly regulated environment. It was a short but important chapter: validating that my path into AI was the right one, and preparing the ground for the next step.
`;
